var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "dynamic-color", rawName: "v-dynamic-color" }],
      staticClass: "wrapper",
      attrs: {
        id: "inspectiv-app",
        ondragstart: "return false;",
        ondrop: "return false;",
        ondragover: "return false;",
      },
    },
    [
      !_vm.isLoggedOutPage ? _c("CaNavbar") : _vm._e(),
      _vm._v(" "),
      !_vm.isLoggedOutPage ? _c("CaSolar") : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "CaAlertsTop", staticClass: "ca-alerts-top" }),
      _vm._v(" "),
      _c("router-view", { key: _vm.$route.fullPath }),
      _vm._v(" "),
      _c("modals-container"),
      _vm._v(" "),
      !_vm.isLoggedOutPage ? _c("CaFooter") : _vm._e(),
      _vm._v(" "),
      _c("CaAlerts"),
      _vm._v(" "),
      _c("div", { ref: "CaAlerts" }),
      _vm._v(" "),
      _c("CaDialogs"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }